module.exports = __webpack_public_path__ + "img/add.cd4bf4b5.svg";